var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-title-layout",class:_vm.clazz},[_c('h1',{class:_vm.titleClass},[_c('small',[_vm._v(_vm._s(_vm.msgSmall))]),_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("buttonsLeft"),_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }